export var VoicingMode;
(function (VoicingMode) {
    VoicingMode[VoicingMode["Monophonic"] = 0] = "Monophonic";
    VoicingMode[VoicingMode["Polyphonic"] = 1] = "Polyphonic";
})(VoicingMode || (VoicingMode = {}));
